import { useState } from "react"
import { useDispatch } from "react-redux"
import Icon from "@mdi/react"
import { mdiCookie } from "@mdi/js"

import "../style/CookieBanner.scss"

function CookieBanner() {
	const [cookieOptions, setCookieOptions] = useState({
		necessary: true,
		preferences: false,
		statistics: false,
		marketing: false,
	})

	const dispatch = useDispatch()

	const handleAccept = () => {
		dispatch({ type: "SET_COOKIE", cookie: cookieOptions })
	}

	const handleAcceptAll = () => {
		const newOptions = {
			necessary: true,
			preferences: true,
			statistics: true,
			marketing: true,
		}

		dispatch({ type: "SET_COOKIE", cookie: newOptions })
	}

	const handleChange = ev => {
		const id = ev.target.id
		setCookieOptions(opts => ({
			...opts,
			[id]: !opts[id],
		}))
	}

	return (
		<div className="banner">
			<div className="banner__container">
				<div className="banner__text">
					<h3>
						<Icon path={mdiCookie} size={2} color="#fff" />
						Acest site utilizează cookie-uri
					</h3>
					<p>
						Folosim cookie-uri pentru a personaliza conținutul și anunțurile,
						pentru a oferi funcții de rețele sociale și pentru a analiza
						traficul. De asemenea, le oferim partenerilor de rețele sociale, de
						publicitate și de analize informații cu privire la modul în care
						folosiți site-ul nostru. Aceștia le pot combina cu alte informații
						oferite de dvs. sau culese în urma folosirii serviciilor lor.
					</p>
				</div>
				<div className="buttons">
					<div className="buttons__buttons">
						<button onClick={handleAccept}>Permite selecția</button>
						<button onClick={handleAcceptAll}>Permite toate</button>
					</div>
					<div className="buttons__checkboxes">
						<div className="buttons__checkboxes__item">
							<input
								type="checkbox"
								id="necesarry"
								name="necesarry"
								checked={true}
								readOnly={true}
							/>
							<label htmlFor="necessary">Necesar</label>
						</div>
						<div className="buttons__checkboxes__item">
							<input
								type="checkbox"
								id="preferences"
								name="preferences"
								checked={cookieOptions.preferences}
								onChange={handleChange}
							/>
							<label htmlFor="preferences">Preferințe</label>
						</div>
						<div className="buttons__checkboxes__item">
							<input
								type="checkbox"
								id="statistics"
								name="statistics"
								checked={cookieOptions.statistics}
								onChange={handleChange}
							/>
							<label htmlFor="statistics">Statistics</label>
						</div>
						<div className="buttons__checkboxes__item">
							<input
								type="checkbox"
								id="marketing"
								name="marketing"
								checked={cookieOptions.marketing}
								onChange={handleChange}
							/>
							<label htmlFor="marketing">Marketing</label>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default CookieBanner
